// extracted by mini-css-extract-plugin
export default {"wrapper":"MadeIactivePro_wrapper__-40Nt","made":"MadeIactivePro_made__Biv7V"};